import React from 'react';

const EmailIcon = ({className}) => (
  <svg className={className} viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.17793 0L9.54312 6.1511L15.7296 0H2.17793ZM0 12.3508L6.36319 5.9633L0 0.58233V12.3521V12.3508ZM7.77319 7.44665L2.12396 13H16.6935L11.2525 7.44665L9.76009 8.93397C9.70177 8.99095 9.6284 9.0227 9.55236 9.02387C9.47631 9.02505 9.40225 8.99556 9.34266 8.9404L7.77319 7.44665ZM12.6537 5.95302L18 11.3945V0.534767L12.6537 5.95302Z" />
  </svg>
);

export default EmailIcon;
